"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var saveToDisk_1 = require("../../../../common/helpers/saveToDisk");
var InstructorCourseAttendanceController = /** @class */ (function () {
    function InstructorCourseAttendanceController(UserService, $state, course, CoursesModel, FlashService, VueStoreFactory) {
        var _this = this;
        this.$state = $state;
        this.course = course;
        this.VueStoreFactory = VueStoreFactory;
        this.CoursesModel = CoursesModel;
        this.FlashService = FlashService;
        this.user = {};
        this.printing = false;
        this.printingRmv = false;
        this.showRmvForm = false;
        var school = UserService.getCurrentUser().school;
        this.rmvSheetsAvailable =
            !!school && !!school.address && school.address.state === "MA";
        this.rmv = { module: "", topic: "" };
        this.loading = true;
        this.currentUserId = UserService.getCurrentUser().id;
        this.studentAttendance = [];
        this.print = this.print.bind(this);
        this.printRmvSignInSheet = this.printRmvSignInSheet.bind(this);
        this.updateAttendance = this.updateAttendance.bind(this);
        this.getAttendance = this.getAttendance.bind(this);
        this.setup()
            .then(function (response) {
            _this.loading = false;
        })
            .catch(function (Error) {
            console.error(Error);
            _this.loading = false;
        });
    }
    InstructorCourseAttendanceController.prototype.classIdForThisCourse = function () {
        return this.VueStoreFactory.getters["courses/classIdForCourse"](this.course.id);
    };
    InstructorCourseAttendanceController.prototype.setup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var course, studentAttendance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.classIdForThisCourse() === 0 && this.course.classes.length > 0) {
                            course = {
                                id: this.course.id,
                                class_id: this.course.classes[0].id,
                                date: new Date(this.course.classes[0].start).toLocaleDateString(),
                                start: new Date(this.course.classes[0].start).toLocaleTimeString("en-US", { hour: "numeric", minute: "numeric" }),
                                end: new Date(this.course.classes[0].end).toLocaleTimeString("en-US", {
                                    hour: "numeric",
                                    minute: "numeric",
                                }),
                            };
                            this.VueStoreFactory.dispatch("SET_VIEW_COURSE", course);
                        }
                        return [4 /*yield*/, this.getAttendance(this.course.id, this.classIdForThisCourse())];
                    case 1:
                        studentAttendance = _a.sent();
                        this.studentAttendance = studentAttendance;
                        return [2 /*return*/];
                }
            });
        });
    };
    InstructorCourseAttendanceController.prototype.print = function () {
        var _this = this;
        this.printing = true;
        this.CoursesModel.printRoster({
            id: this.course.id,
            class_id: this.classIdForThisCourse(),
        }).then(function (response) {
            _this.printing = false;
            (0, saveToDisk_1.saveToDisk)(response.file.url, response.file.name);
        });
    };
    InstructorCourseAttendanceController.prototype.printRmvSignInSheet = function () {
        var _this = this;
        this.printingRmv = true;
        this.CoursesModel.printRmvSignInSheet({
            id: this.course.id,
            class_id: this.classIdForThisCourse(),
            module: this.rmv.module,
            topic: this.rmv.topic,
        })
            .then(function (response) {
            _this.printingRmv = false;
            _this.showRmvForm = false;
            (0, saveToDisk_1.saveToDisk)(response.file.url, response.file.name);
        })
            .catch(function () {
            _this.printingRmv = false;
        });
    };
    InstructorCourseAttendanceController.prototype.getAttendance = function (courseId, class_id) {
        return this.CoursesModel.getCourseClassAttendance(courseId, class_id).then(function (response) {
            return response;
        });
    };
    InstructorCourseAttendanceController.prototype.updateAttendance = function (data) {
        var _this = this;
        //data is an object with keys courseId and students which is an array of students w classDates
        var submitData = (0, lodash_1.cloneDeep)(data);
        submitData.class_id = this.classIdForThisCourse();
        //remove classDates with null values for present key bc we arent saving those dates
        var studentsWithNoNulls = submitData.students.map(function (student) {
            var datesWithNoNulls = student.classDates.filter(function (classDate) {
                return classDate.present !== null;
            });
            student.classDates = datesWithNoNulls;
            return student;
        });
        submitData.students = studentsWithNoNulls;
        this.CoursesModel.updateCourseClassAttendance(submitData).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        });
    };
    return InstructorCourseAttendanceController;
}());
InstructorCourseAttendanceController.$inject = [
    "UserService",
    "$state",
    "course",
    "CoursesModel",
    "FlashService",
    "VueStoreFactory",
];
exports.default = InstructorCourseAttendanceController;
